import * as React from 'react'
import type {SVGProps} from 'react'
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} viewBox="0 0 19 19" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.58 1.92a5.66 5.66 0 1 0 0 11.32 5.66 5.66 0 0 0 0-11.32M7.6 0a7.6 7.6 0 0 1 6.004 12.26l5.118 5.118a.951.951 0 0 1-1.343 1.344l-5.118-5.118A7.6 7.6 0 1 1 7.6 0"
        />
    </svg>
)
export default SvgSearch
